module.exports = __webpack_public_path__ + "img/68.eecf153c.jpg";